var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkArrowBigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#1273C0",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 25.2929C12.9024 25.6834 12.9024 26.3166 13.2929 26.7071C13.6834 27.0976 14.3166 27.0976 14.7071 26.7071L14 26L13.2929 25.2929ZM26.9996 14.0004C26.9996 13.4481 26.5519 13.0004 25.9996 13.0004L16.9996 13.0004C16.4473 13.0004 15.9996 13.4481 15.9996 14.0004C15.9996 14.5527 16.4473 15.0004 16.9996 15.0004L24.9996 15.0004L24.9996 23.0004C24.9996 23.5527 25.4473 24.0004 25.9996 24.0004C26.5519 24.0004 26.9996 23.5527 26.9996 23.0004L26.9996 14.0004ZM14 26L14.7071 26.7071L26.7067 14.7075L25.9996 14.0004L25.2925 13.2933L13.2929 25.2929L14 26Z",
    fill: "#1273C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrowBigIcon);
export default __webpack_public_path__ + "static/media/link_arrow_big_icon.60dab54c10cccb22e29efc44347a37c7.svg";
export { ForwardRef as ReactComponent };